import axios from "axios";
import { toast } from "react-toastify";

const API_BASE_URL = process.env.REACT_APP_MAIN_URL || "http://localhost:8080";

// Action Types
export const GET_SPORTS_REQUEST = "GET_SPORTS_REQUEST";
export const GET_SPORTS_SUCCESS = "GET_SPORTS_SUCCESS";
export const GET_SPORTS_FAILURE = "GET_SPORTS_FAILURE";

export const GET_SPORT_BY_ID_REQUEST = "GET_SPORT_BY_ID_REQUEST";
export const GET_SPORT_BY_ID_SUCCESS = "GET_SPORT_BY_ID_SUCCESS";
export const GET_SPORT_BY_ID_FAILURE = "GET_SPORT_BY_ID_FAILURE";

export const ADD_SPORT_REQUEST = "ADD_SPORT_REQUEST";
export const ADD_SPORT_SUCCESS = "ADD_SPORT_SUCCESS";
export const ADD_SPORT_FAILURE = "ADD_SPORT_FAILURE";

export const UPDATE_SPORT_REQUEST = "UPDATE_SPORT_REQUEST";
export const UPDATE_SPORT_SUCCESS = "UPDATE_SPORT_SUCCESS";
export const UPDATE_SPORT_FAILURE = "UPDATE_SPORT_FAILURE";

export const DELETE_SPORT_REQUEST = "DELETE_SPORT_REQUEST";
export const DELETE_SPORT_SUCCESS = "DELETE_SPORT_SUCCESS";
export const DELETE_SPORT_FAILURE = "DELETE_SPORT_FAILURE";

export const SEARCH_SPORTS_REQUEST = "SEARCH_SPORTS_REQUEST";
export const SEARCH_SPORTS_SUCCESS = "SEARCH_SPORTS_SUCCESS";
export const SEARCH_SPORTS_FAILURE = "SEARCH_SPORTS_FAILURE";

// Get All Sports
export const GetSports = (page = 0, token) => async (dispatch) => {
  dispatch({ type: GET_SPORTS_REQUEST });
  try {
   /* const response = await axios.get(`${API_BASE_URL}api/sports`, {
      params: { page, size: 10 },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });*/

    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const response = await axios.get(`${API_BASE_URL}api/sports`, {
      params: { page, size: 100 },
      headers,
    });

    dispatch({ type: GET_SPORTS_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: GET_SPORTS_FAILURE, payload: error.message });
    toast.error(error.response?.data?.message || "Failed to fetch sports");
  }
};

// Get Sport By ID
export const GetSportById = (sportId, token) => async (dispatch) => {
  dispatch({ type: GET_SPORT_BY_ID_REQUEST });
  try {
    const response = await axios.get(`${API_BASE_URL}api/sports/${sportId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({ type: GET_SPORT_BY_ID_SUCCESS, payload: response.data.data });
  } catch (error) {
    dispatch({ type: GET_SPORT_BY_ID_FAILURE, payload: error.message });
    toast.error(error.response?.data?.message || "Failed to fetch sport details");
  }
};

// Add Sport
export const Add_Sport = (sportData, token, navigate) => async (dispatch) => {
  dispatch({ type: ADD_SPORT_REQUEST });
  try {
    const response = await axios.post(`${API_BASE_URL}api/sports`, sportData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    dispatch({ type: ADD_SPORT_SUCCESS, payload: response.data });
    toast.success("Sport added successfully!");
    navigate("/dashboard/allsports");
  } catch (error) {
    dispatch({ type: ADD_SPORT_FAILURE, payload: error.message });
    toast.error(error.response?.data?.message || "Failed to add sport");
  }
};

// Update Sport
export const Update_Sport = (sportId, sportData, token, navigate) => async (dispatch) => {
  dispatch({ type: UPDATE_SPORT_REQUEST });
  try {
    const response = await axios.put(
      `${API_BASE_URL}api/sports/${sportId}`,
      sportData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    dispatch({ type: UPDATE_SPORT_SUCCESS, payload: response.data });
    toast.success("Sport updated successfully!");
    navigate("/dashboard/allsports");
  } catch (error) {
    dispatch({ type: UPDATE_SPORT_FAILURE, payload: error.message });
    toast.error(error.response?.data?.message || "Failed to update sport");
  }
};

// Delete Sport
export const DelSport = (sportId, token, callback) => async (dispatch) => {
  dispatch({ type: DELETE_SPORT_REQUEST });
  try {
    await axios.delete(`${API_BASE_URL}api/sports/${sportId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({ type: DELETE_SPORT_SUCCESS });
    toast.success("Sport deleted successfully!");
    if (callback) callback();
  } catch (error) {
    dispatch({ type: DELETE_SPORT_FAILURE, payload: error.message });
    toast.error(error.response?.data?.message || "Failed to delete sport");
  }
};

// Search Sports
export const getSportsBySearch = (searchQuery, page = 0, token) => async (dispatch) => {
  dispatch({ type: SEARCH_SPORTS_REQUEST });
  try {
    const response = await axios.get(`${API_BASE_URL}api/sports/search`, {
      params: { 
        name: searchQuery, 
        page, 
        size: 10 
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({ type: SEARCH_SPORTS_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: SEARCH_SPORTS_FAILURE, payload: error.message });
    toast.error(error.response?.data?.message || "Failed to search sports");
  }
};
